import React from "react";
import "./Product_Info_Card.css";
import Green_Outline_Btn from "../common_btn/green_outline_btn/Green_Outline_Btn";
import Best_seller_heart from "../product_card/Best_seller_heart/Best_seller_heart";
import Add_to_card_btn from "../common_btn/Add_to_card_btn/Add_to_card_btn";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import { useSelector } from "react-redux";

const Product_Info_Card = ({
  id,
  imgSrc,
  vdoSrc,
  productName,
  priceText,
  mrp,
  product,
}) => {
  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";
  return (
    <div className="Product_Info_Card">
      <Link to={`/product-details/${encodeId(product?.id)}`}>
        <div className="prod_img_holder">
          <img src={imgSrc} className="prod_img" alt={productName} />

          <video
            className="prod_video"
            src={vdoSrc}
            muted
            loop
            playsInline
            autoPlay
          />
        </div>
      </Link>

      <div className="best_seller_heart_holder">
        <Best_seller_heart product={product} />
      </div>

      <div className="content_holder">
        <div className="middle_div">
          <Link to={`/product-details/${encodeId(product?.id)}`}>
            <p className="prod_name">{productName}</p>
          </Link>
          <div className="price_div">
            <p className="mrp_text">
              {symbol} {Number(mrp * rate).toFixed(2)}
            </p>
            <p className="s_price_text">
              {symbol} {Number(priceText * rate).toFixed(2)}
            </p>
          </div>
          
        </div>

        <div className="btn_holder">
          <Add_to_card_btn id={product?.id} product={product} />
        </div>
      </div>
    </div>
  );
};

export default Product_Info_Card;
